
import { createApi } from "@reduxjs/toolkit/query/react";
import { transformErrorResponse, transformSucessResponse } from "../../../../utils/API/responseMiddleware";
import { transformRequest } from "../../../../utils/API/requestMiddleware";
import { defautBaseQuery } from "../../../../utils/API/fetchBaseQuery";

const eventFeedbackQuestionApi = createApi({
    baseQuery: defautBaseQuery,
    reducerPath: 'eventFeedbackQuestionApi',
    endpoints: (builder) => ({
        getFeedbackQuestionEntryDetailListApi: builder.mutation({
            query: (details) => ({
                url: '/EventManagement/GetFeedbackQuestionEntryDetailList',
                method: 'POST',
                body: transformRequest(details)
            }),
            transformResponse: transformSucessResponse,
            transformErrorResponse: transformErrorResponse,
        }),
    }),
});

export const {
    useGetFeedbackQuestionEntryDetailListApiMutation,
} = eventFeedbackQuestionApi;

export default eventFeedbackQuestionApi;